export default __webpack_public_path__ + "static/media/linkedin.b8837632.svg";